import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import DICOMContainer from './ViewerComponents/DICOMContainer';
import ReportEditor from './ViewerComponents/ReportEditor';
import { useOrder } from '../context/ViewerOrderContext';
import CustomSnackbar from './CustomSnackbar';

const FullScreenContainer = styled.div`
  width: 100vw;
  height: 100%;
  ${'' /* padding-top: 3vh; */}
  display: flex;
  flex-direction: column;
  background-color: #000;
  overflow: hidden;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 0 16px;
  gap: 16px;
`;

const CollapseButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  cursor: pointer;
  z-index: 1;
  background-color: #000;
`;

const CollapseButton = styled.button`
  background-color: #333;
  border: 1px solid #555;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
    stroke: #fff;
  }

  &:hover {
    background-color: #444;
  }
`;

const ViewerContainer = styled.div`
  display: flex;
  height: 100vh;
  background: #000;
  color: #fff;
`;

const BackButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: #333;
  border: 1px solid #555;
  border-radius: 8px;
  padding: 8px 16px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1000;

  &:hover {
    background-color: #444;
  }
`;

const Viewer = () => {
  const { orderData } = useOrder();
  const [isReportCollapsed, setIsReportCollapsed] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('error');

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Escape') {
        setIsReportCollapsed(!isReportCollapsed);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [isReportCollapsed]);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <FullScreenContainer>
      <Container>
        <DICOMContainer
          collapsed={isReportCollapsed}
          studyId={orderData?.data?.dicom_study_id}
          viewerToken={orderData?.viewerToken}
        />
        <ReportEditor
          collapsed={isReportCollapsed}
          studyId={orderData?.data?.dicom_study_id}
          orderId={orderData?.orderId}
          displayOrderId={orderData?.displayOrderId}
          patientName={orderData?.patientName}
          age={orderData?.age}
          sex={orderData?.sex}
          clinicalDetails={orderData?.data?.clinical_notes}
          clinicalDocs={orderData?.data?.clinical_doc_array}
          priorCases={orderData?.data?.prior_cases}
          labUserId={orderData?.labUserId}
        />
      </Container>
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleCloseSnackbar}
      />
    </FullScreenContainer>
  );
};

export default Viewer; 